module.exports = [
    "Masculino",
    "Feminino",
    "Outro",
    "Prefiro não informar",
]